module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Betrag","track":"Amount"}}